<script lang="jsx">
import cartMixin from '@/plans/mx/shopping-cart';
import configMixin from './mixin';

export default {
  mixins: [cartMixin, configMixin],
  name: 'ZCMStorageCart',
  methods: {
    $renderPrice() {
      if (!this.mx_plans.length) return;
      return (
        <div class="opc-cart-item">
          {this.mx_plans.map((plan) => {
            return (
              <div>
                {this.mx_title(this.title, this.mx_price(plan))}
                {this.mx_discount(plan.plan_code)}
                {this.mx_cycle(plan.billing_cycle)}
                {this.mx_license(plan.cartCapacity, plan.cartCapacityUnit)}
                {this.mx_edit(plan)}
                {this.mx_remove(plan)}
              </div>
            );
          })}
        </div>
      );
    },
  },
};
</script>

<style lang="scss" scoped>
:deep .opc-cart-item__title {
  text-transform: none;
}
</style>
